import React from 'react';
import uniqueId from 'lodash/uniqueId';
const LiteratureCoverLetter = ({ deviation: { title } })=>{
    var _title_replace;
    const filteredTitle = (_title_replace = title === null || title === void 0 ? void 0 : title.replace(/[^a-zA-Z]/g, '')) !== null && _title_replace !== void 0 ? _title_replace : '';
    if (!filteredTitle.length) {
        return null;
    }
    const gradientId = `lit-gradient${uniqueId()}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-literature-letter"
    }, /*#__PURE__*/ React.createElement("svg", {
        height: "100%",
        viewBox: "0 0 15 12",
        preserveAspectRatio: "xMidYMin slice",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        x1: "100%",
        y1: "16.1729237%",
        x2: "100%",
        y2: "83.3711592%",
        id: gradientId
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00FF77",
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#3197EF",
        stopOpacity: "0",
        offset: "100%"
    })), /*#__PURE__*/ React.createElement("text", {
        className: "daeditor-literature-letter-inner",
        fill: `url(#${gradientId})`,
        x: "15",
        y: "-9%",
        textAnchor: "end",
        alignmentBaseline: "hanging"
    }, filteredTitle[0])));
};
LiteratureCoverLetter.displayName = 'LiteratureCoverLetter';
export default LiteratureCoverLetter;

//# sourceMappingURL=HtmlLiteratureCoverLetter.js.map